import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getNookClient } from "../client.js";
import { NookApiError } from "../http.js";
import { queryKeys } from "../query-keys.js";
export function useDeleteAskThread() {
    const queryClient = useQueryClient();
    return useMutation({
        // A `404` is a thread already gone — done, not a failure to roll back.
        mutationFn: (id) => getNookClient()
            .deleteAskThread(id)
            .catch((err) => {
            if (!(err instanceof NookApiError && err.status === 404))
                throw err;
        }),
        retry: 1,
        async onMutate(id) {
            await queryClient.cancelQueries({ queryKey: queryKeys.ask.threads() });
            const snapshot = queryClient.getQueryData(queryKeys.ask.threads());
            queryClient.setQueryData(queryKeys.ask.threads(), (current) => current && {
                ...current,
                pages: current.pages.map((page) => ({ ...page, items: page.items.filter((item) => item.id !== id) })),
            });
            return { snapshot };
        },
        onError(_error, _id, context) {
            queryClient.setQueryData(queryKeys.ask.threads(), context?.snapshot);
        },
        onSuccess(_result, id) {
            queryClient.removeQueries({ queryKey: queryKeys.ask.thread(id) });
        },
        onSettled() {
            void queryClient.invalidateQueries({ queryKey: queryKeys.ask.threads() });
        },
    });
}
//# sourceMappingURL=use-delete-ask-thread.js.map